import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../Pages/Login.css";

function Forgot() {
  const [isuserdetailsopen, setisuserdetailsopen] = useState(true);
  const [isotpopen, setisotpopen] = useState(false);
  const [isnewpasswordopen, setisnewpasswordopen] = useState(false);
  const [otp, setotp] = useState([]);
  const [enteredOtp, setEnteredOtp] = useState({ 1: "", 2: "", 3: "", 4: "" });
  const [timeLeft, setTimeLeft] = useState(120);
  const [otpExpired, setOtpExpired] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [password, setpassword] = useState({
    userId: "",
    email: "",
    otp: "",
    password: "",
    newpassword: "",
  });

  const navigate = useNavigate();

  const handleforgotpass = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/login_forgotpass.php`;
    const formData = new FormData();
    try {
      const formData = new FormData();
      formData.append("emp_id", password?.userId);
      formData.append("phone_email", password?.email);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message === "Record fetched successfully") {
        setpassword({
          email: "",
          otp: "",
          password: "",
          newpassword: "",
        });
        setisotpopen(true);
        setisuserdetailsopen(false);
        setotp(data.data);
      } else {
        alert("User Doesn`t exist");
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setIsSubmitting(false); // Stop blur
    }
  };

  const handlelogin = () => {
    navigate("/");
  };

  const handleverify = async (e) => {
    e.preventDefault();
    const enteredCode = Object.values(enteredOtp).join("");

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/verifyotp.php`;
    const formData = new FormData();
    try {
      const formData = new FormData();
      formData.append("enterotp", enteredCode);
      formData.append("sendotp", otp?.otp);
      formData.append("iv", otp?.iv);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.message === "OTP verified") {
        toast.success("OTP verified successfully!");
        setisotpopen(false);
        setisnewpasswordopen(true);
      } else {
        toast.error("Incorrect OTP. Please try again.");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      toast.error("Verification failed. Try again later.");
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      setEnteredOtp((prev) => ({ ...prev, [index]: value }));
      if (value && index < 4) {
        const nextInput = document.getElementById(`otp-input${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleResendOtp = async () => {
    startOtpTimer(); // Restart timer
    toast.success("OTP resent successfully.");

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/resendotp.php`;
    const formData = new FormData();
    try {
      const formData = new FormData();
      formData.append("phone_email", otp?.email);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.message === "Record fetched successfully") {
        setpassword({
          email: "",
          otp: "",
          password: "",
          newpassword: "",
        });
        setotp(data.data);
      } else {
        toast.error("User Doesn`t exist");
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const handleupdatepassword = async () => {
    if (password?.password === password?.newpassword) {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/modifyuser.php`;
      const formData = new FormData();

      try {
        const formData = new FormData();

        formData.append("emp_id", otp?.id);
        formData.append("password", password?.password);
        formData.append("type", "user");
        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        if (data.message === "Password updated successfully") {
          toast.success("Password updated successfully!");
          navigate("/");
          setpassword({
            userId: "",
            email: "",
            otp: "",
            password: "",
            newpassword: "",
          });
        } else {
          alert("Error occurred on the updating password");
        }
      } catch (error) {
        console.error("Error updating password:", error);
      }
    } else {
      toast.error("Please ensure both passwords match!");
      setpassword({
        password: "",
        newpassword: "",
      });
    }
  };

  const startOtpTimer = () => {
    setTimeLeft(120);
    setOtpExpired(false);

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setOtpExpired(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return timer;
  };

  useEffect(() => {
    if (isotpopen) {
      const timer = startOtpTimer();
      return () => clearInterval(timer); // Cleanup on unmount
    }
  }, [isotpopen]);

  useEffect(() => {
    if (otpExpired) {
      toast.error("OTP has expired. Please resend.");
    }
  }, [otpExpired]);

  return (
    <div className="wrapper">
      <div className="lohead">
        {isuserdetailsopen && (
          <form
            onSubmit={handleforgotpass}
            className={isSubmitting ? "blurred" : "loginform"}
          >
            <div className="heading">Forgot Password</div>
            <div className="container-1">
              <div className="group">
                <input
                  required
                  className="main-input"
                  name="email"
                  type="text"
                  value={password?.userId}
                  onChange={(e) =>
                    setpassword((prev) => ({ ...prev, userId: e.target.value }))
                  }
                />
                <span className="highlight-span" />
                <label className="lebal-email">Employee ID</label>
              </div>
            </div>
            <div className="container-1">
              <div className="group">
                <input
                  className="main-input"
                  required
                  name="password"
                  type="text"
                  value={password?.email}
                  onChange={(e) =>
                    setpassword((prev) => ({ ...prev, email: e.target.value }))
                  }
                />
                <span className="highlight-span" />
                <label className="lebal-email">Email</label>
              </div>
            </div>
            <button className="submit" type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Please wait..." : "Get OTP"}
            </button>

            <div className="signup-link">
              Don't have an account? <a onClick={handlelogin}>Sign up</a>
            </div>
          </form>
        )}

        {isotpopen && (
          <form className="otp-Form" onSubmit={handleverify}>
            <span className="heading">Enter OTP</span>
            <p className="otpSubheading">
              We have sent a verification code to this{" "}
              <strong>{otp?.email} </strong>
              email.
              <br />
            </p>
            <div className={`inputContainer ${otpExpired ? "blurred" : ""}`}>
              <input
                required
                maxLength={1}
                type="text"
                className="otp-input"
                id="otp-input1"
                onChange={(e) => handleOtpChange(e, 1)}
                value={enteredOtp[1]}
              />
              <input
                required
                maxLength={1}
                type="text"
                className="otp-input"
                id="otp-input2"
                onChange={(e) => handleOtpChange(e, 2)}
                value={enteredOtp[2]}
              />
              <input
                required
                maxLength={1}
                type="text"
                className="otp-input"
                id="otp-input3"
                onChange={(e) => handleOtpChange(e, 3)}
                value={enteredOtp[3]}
              />
              <input
                required
                maxLength={1}
                type="text"
                className="otp-input"
                id="otp-input4"
                onChange={(e) => handleOtpChange(e, 4)}
                value={enteredOtp[4]}
              />
            </div>
            <button
              className={`verifyButton ${otpExpired ? "blurred" : ""}`}
              type="submit"
            >
              Verify
            </button>

            {otpExpired ? (
              <p className="resendNote">
                Didn't receive the code?{" "}
                <button
                  className="resendBtn"
                  type="button"
                  onClick={handleResendOtp}
                >
                  Resend Code
                </button>
              </p>
            ) : (
              <p>
                <strong className={`${otpExpired ? "red" : ""}`}>
                  Expires in:{" "}
                  <span className="times">
                    {Math.floor(timeLeft / 60)}:
                    {String(timeLeft % 60).padStart(2, "0")}
                  </span>
                </strong>
              </p>
            )}
          </form>
        )}

        {isnewpasswordopen && (
          <div className="loginform">
            <div className="heading">Change Password</div>
            <div className="container-1">
              <div className="group">
                <input
                  required
                  className="main-input"
                  type="password"
                  value={password?.password}
                  onChange={(e) =>
                    setpassword((prev) => ({
                      ...prev,
                      password: e.target.value,
                    }))
                  }
                />
                <span className="highlight-span" />
                <label className="lebal-email">New Password</label>
              </div>
            </div>
            <div className="container-1">

            <div className="group">
              <input
                required
                className="main-input"
                type="password"
                value={password?.newpassword}
                onChange={(e) =>
                  setpassword((prev) => ({
                    ...prev,
                    newpassword: e.target.value,
                  }))
                }
              />
              <span className="highlight-span" />
              <label className="lebal-email">Confirm New Password</label>
            </div>
            </div>

            <button className="submit" onClick={handleupdatepassword}>
              Update Password
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Forgot;
